import { PageSEO } from '@/components/SEO';

export default function About() {
  return (
    <div className="min-h-screen pt-32 pb-16">
      <PageSEO.about />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl md:text-6xl font-medium mb-8">About Twenty Tulips</h1>
        <div className="prose prose-stone max-w-none">
          <p className="text-lg leading-relaxed text-stone-700">
            Welcome to Twenty Tulips, your destination for premium quality shawls. 
            We curate the finest collection of shawls crafted from luxurious materials.
          </p>
        </div>
      </div>
    </div>
  );
}
